import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Boxes } from "lucide-react";

/**
 * El llamado a la franquicia, encima de la lista: los paquetes de
 * negocio digital se contratan con franquicia activa.
 */
export function WholesaleUpsellNote() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-ds-border bg-ds-lavender-bg-2/50 px-5 py-4">
      <span className="flex min-w-0 items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-ds-violet-pop text-white">
          <Boxes className="h-4 w-4" />
        </span>
        <span className="text-[14px] leading-relaxed text-ds-ink">
          {t("¿Buscas un paquete de mayor volumen?")}{" "}
          <span className="font-semibold">
            {t("Conviértete en mayorista con tu franquicia It's The Best.")}
          </span>
        </span>
      </span>
      <span className="flex flex-wrap items-center gap-4">
        <Link
          to="/franquicias"
          className="group inline-flex items-center gap-1.5 text-[13px] font-semibold text-ds-violet-pop"
        >
          {t("Adquirir franquicia")}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </span>
    </div>
  );
}
